export default __webpack_public_path__ + "static/media/_logo-invoice-error.c6d16077.svg";